
import type Vue from 'vue'
import { defineComponent, getCurrentInstance } from 'vue'
import { ColorEnum } from '../../enums'
import AppHeaderUser from '../app-header-user.component.vue'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'NavigationMenuFooter',
  components: { EpbText, AppHeaderUser },
  props: {
    collapsed: Boolean,
    animationDurationInMillis: Number,
  },
  setup() {
    const {
      proxy: { $epb },
    } = getCurrentInstance() as { proxy: Vue }

    const baseClass = 'epb-navigation-menu-footer'

    return {
      baseClass,
      ColorEnum,
    }
  },
})
